/*

  # Tab Folders

  Each tabFolders.tab, typically a button, has
  a corresponding tabFolders.folder whic share
  a unique identifier in the data-folder attribute:

  <button
    type="button"
    data-hook="tabFolders.tab"
    data-folder="folder-a">
    Tab A
  </button>
  <button
    type="button"
    data-hook="tabFolders.tab"
    data-folder="folder-b">
    Tab B
  </button>

  <div
    data-hook="tabFolders.folder"
    data-folder="folder-a">
    Folder A
  </div>
  <div
    data-hook="tabFolders.folder"
    data-folder="folder-b">
    Folder B
  </div>

  Both tabs and folders support the
  data-class-active and data-class-inactive
  class state attributes. Use either the display
  or visibility properties to ensure that
  inactive folders are hidden from screen readers.

  The tabs are optional, for example if you're
  using this with the pagedTabFolders to apply
  paging instead of tabs.

*/

import { assignController, selectAll } from '../api/element-manipulation'
import createTabGroup from '../api/create-tab-group'

assignController('tabFolders', (element) => {
  const tabs = selectAll(element, '[data-hook~="tabFolders.tab"]')
  const folders = selectAll(element, '[data-hook~="tabFolders.folder"]')
  const tabGroup = createTabGroup({
    tabs,
    folders,
    closeButtons: [],
  })
  if (element.dataset.initialFolder) {
    setTimeout(() => {
      tabGroup.openById(element.dataset.initialFolder)
    }, 0)
  }
  const controller = {
    tabGroup,
    tabs,
    folders,
  }
  return controller
})
